import React, { useEffect, useRef, useState } from "react";
import Modal from "@/components/Modal";
import { useTranslation } from "@/langs/useTranslation";
// import { toast } from "@/apis/request";
import TagList from "@/components/FormFields/TagList";
import MemoedHOC from "@/hoc/MemoedHOC";

function TranserModal({ open, value, onSelect, onConfirm, onClose }) {
  const { t } = useTranslation();
  const [selected, setSelected] = useState([]);
  const tagRef = useRef();

  const handleConfirm = () => {
    // if (!selected.length) {
    //   toast.info(t({ defaultMessage: "请选择一个标签" }));
    //   return;
    // }
    return onConfirm?.(
      selected,
      tagRef.current.getOptions().filter(item => selected.includes(item.id))
    );
  };

  const handleChange = e => {
    const { value } = e.target;
    setSelected(value);
    onSelect?.(
      value,
      tagRef.current.getOptions().find(item => value.includes(item.id))
    );
  };

  useEffect(() => {
    if (!open) {
      setSelected([]);
    }
  }, [open]);

  useEffect(() => {
    if (value) {
      setSelected(value);
    }
  }, [value]);

  return (
    <Modal
      title={t({ defaultMessage: "贴标签" })}
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
    >
      <TagList ref={tagRef} value={selected} onChange={handleChange} />
    </Modal>
  );
}

export default MemoedHOC(TranserModal);
